import { SideBarDialog } from 'shared/components';
import { AlertBanner, ComplaintComment } from './components';
import { ItemInfoCardWithAvatar } from 'features/mozart-notifications/components/shared';

import { useTLang } from 'intl/intl';

import makeClasses from './MozartComplaintDialog.style';

import type { SideBarDialogProps } from 'shared/components';
import type { MozartComplaint } from 'features/mozart-notifications/domain';

export function MozartComplaintDialog(props: Props) {
  const { complaint, ...restProps } = props;

  const lang = {
    headerDialog: {
      title: useTLang({ id: 'notification.mozart.033' }),
    },
    mainSection: {
      title: useTLang({ id: 'notification.mozart.025' }),
    },
    comments: {
      title: useTLang({ id: 'notification.mozart.021' }),
    },
  };

  const _classes = makeClasses();

  return (
    <SideBarDialog
      aria-label='mozart-complaint-dialog'
      data-complaint-seen={complaint.seen}
      data-complaint-reason={complaint.reason}
      headerTitle={lang.headerDialog.title}
      classesHeader={{ title: _classes.headerDialogTitle }}
      classesMain={{ main: _classes.mainDialog }}
      posNav={<AlertBanner seen={complaint.seen} reason={complaint.reason} />}
      {...restProps}
    >
      <ItemInfoCardWithAvatar
        title={lang.mainSection.title}
        info={{
          title: complaint.title,
          imageUrl: complaint.imageUrl,
          description: complaint.description,
        }}
      />

      <aside className={_classes.baseSections}>
        <h3 className={_classes.subTitle}>
          {lang.comments.title}
          {complaint.comments.length}
        </h3>
        {complaint.comments.map(comment => (
          <ComplaintComment key={comment.id} {...comment} />
        ))}
      </aside>
    </SideBarDialog>
  );
}

interface Props extends Partial<SideBarDialogProps> {
  complaint: MozartComplaint;
}
